import * as React from 'react';
import { FavouriteLayoutComponentProps } from '../types';
import { TableFavouriteModelComponent } from './table-favourite-model-component';
import { TileField } from './tile';
import { mapToRows, shouldDisplayTotal } from './view-model';
import { FavouriteRow, RegularField, AggregatedField } from './types';
import { tileConfig } from './config';

import styles from './tile-view-favourite.scss';
import { Link } from 'react-router-dom';

export class TileViewFavourite extends React.PureComponent<FavouriteLayoutComponentProps> {
  private model: TableFavouriteModelComponent;

  constructor(props: FavouriteLayoutComponentProps) {
    super(props);
    this.model = new TableFavouriteModelComponent(
      props.layoutAttributes, props.intl, props.translation, undefined, this.props.drillDown, this.props.caseview);

      if (props.favouriteDataModel) {
        this.model.receiveData(props.favouriteDataModel);
      }
  }

  public componentDidUpdate(prevProps: FavouriteLayoutComponentProps) {
    if (this.props.layoutAttributes) {
      if (!this.props.fetchingDataModel && this.props.favouriteDataModel !== prevProps.favouriteDataModel) {
        this.model.receiveData(this.props.favouriteDataModel);
      }
    }
  }

  public render() {

    if (!this.model || !this.model.dataModel || !this.model.dataModel.rows || this.model.dataModel.rows.length === 0) {
      return <div className={styles.spinLoader} />;
    }
    const { dataModel: { columns, rows, report }, dataAdapter } = this.model;
    const { compactView, wideLayout, hideHeader, hideAggrColumns, hideTotals } = tileConfig(this.props.layoutAttributes);

    const data = mapToRows(dataAdapter, this.model, rows, columns, compactView);

    return <div>
      {!hideTotals && shouldDisplayTotal(dataAdapter, columns, report) && this.renderTotal()}
      <div className={wideLayout ? styles.tileAreaWide : `${styles.tileAreaNarrow} grid-250`}>
        {data.map((tile, index) => this.renderTile(tile, wideLayout, hideHeader, hideAggrColumns, index))}
      </div>
    </div>;
  }

  private renderTotal = () => {
    const { dataModel: { columns }, dataAdapter: { aggrColIndex } } = this.model;
    const total = this.model.getFooterColumnTextAndValue(columns[aggrColIndex].aggregationType);

    return total.value !== undefined && <p>
      {!!total.label && <span className={styles.totalLabel}>{total.label}: </span>}
      <span className={styles.totalValue}>{total.value}</span></p>;
  };

  private renderTile = (tile: FavouriteRow, wideLayout: boolean, hideHeader: boolean, hideAggrColumns: boolean, key: number) => {

    // Check if there is anything to render
    if ((hideAggrColumns || (!tile.subValue && !tile.rollingAvarage && !tile.target))
      && tile.selectionValues.length === 0
      && !tile.aggregateValue) {
      return null;
    }

    return <div key={key} className={wideLayout ? styles.tileWide : styles.tileNarrow}>
      {!hideAggrColumns && !!tile.subValue && this.renderSubvalue(tile.subValue, wideLayout)}
      <div className={`${styles.tileFields} grid-150`}>
        {tile.selectionValues.map((field, index) => this.renderRegularField(field, wideLayout, hideHeader, index))}
        {!!tile.aggregateValue && this.renderAggregateArea(tile.aggregateValue, wideLayout, hideHeader)}
        {!hideAggrColumns && !!tile.rollingAvarage && this.renderAggregateArea(tile.rollingAvarage, wideLayout, hideHeader)}
        {!hideAggrColumns && !!tile.target && this.renderAggregateArea(tile.target, wideLayout, hideHeader)}
      </div>
    </div>;
  };

  private renderRegularField = (field: RegularField, wideLayout: boolean, hideHeader: boolean, key?: number) => {
    return <TileField
      key={key}
      className={wideLayout ? styles.tileFieldWide : undefined}
      tooltip={field.tooltip}
      label={!hideHeader && field.label}
      value={field.value}
      iconUrl={field.iconUrl}
      bgColour={field.bgColour}
      bgColourDark={field.bgColourDark}
      onClick={field.onClick}
      url={field.url} />;
  };

  private renderSubvalue = (field: RegularField, wideLayout: boolean) => {
    const smallFontSize = field.value.length > 6 ? styles.smallFontSize : '';
    const value = field.url ?
      <Link tabIndex={0} to={field.url}>{field.value}</Link> :
      field.value;

    return <div title={field.tooltip}
      onClick={field.onClick}
      className={`${(field.onClick || field.url) ? styles.tileWithDrilldown : styles.tileNoDrilldown}`}>
      <p className={`${styles.tileAggregationValue} ${smallFontSize}`}
        style={field.bgColour && { color: field.bgColour }}>{value}</p>
    </div>;
  };

  private renderAggregateArea = (field: RegularField | AggregatedField, wideLayout: boolean, hideHeader: boolean) => {

    const aggregateField = field as AggregatedField;

    if (aggregateField.values) {
      return <div title={field.tooltip} className={wideLayout ? styles.tileFieldWide : undefined}>
        {aggregateField.values.map((f, i) => <TileField
          key={i}
          tooltip={f.tooltip}
          label={!hideHeader && i === 0 && field.label}
          value={`${f.value} (${f.aggregatedValue})`}
          iconUrl={f.iconUrl}
          bgColour={f.bgColour}
          bgColourDark={f.bgColourDark}
          onClick={f.onClick} />)}
      </div>;
    }

    return this.renderRegularField(field as RegularField, wideLayout, hideHeader);
  };
}
